import type { ReactNode } from "react";
export default function LeagueFeedback({ children }: { children: ReactNode }) {
  return <div className="league-feedback" role="status" aria-live="polite">
    <span className="material-symbols-outlined" aria-hidden="true">info</span><div>{children}</div>
  </div>;
}
